import "./CertificateGroupingGWPConcrete.scss";
import CertificateGroupingListGWPConcreteReviewForm from "../../features/CertificateGroupingListGWPConcreteReviewForm/CertificateGroupingListGWPConcreteReviewForm";

const CertificateGroupingGWPConcreteForReview = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingListGWPConcreteReviewForm />
    </div>
  );
};

export default CertificateGroupingGWPConcreteForReview;
